import './About.css'

export default function About() {
  return (
    <section className="about section" id="about">
      <div className="container">
        <div className="about__inner">
          {/* Photo placeholder */}
          <div className="about__photo-wrap">
            <div className="about__photo-placeholder">
              <img src="/charlie.jpg" alt="Charlie Brook — Founder, NorthCortex" className="about__photo-img" />
            </div>
            <div className="about__photo-badge">
              <ShieldIcon />
              <span>Principal Consultant</span>
            </div>
          </div>

          {/* Bio */}
          <div className="about__content">
            <span className="section-eyebrow">The Founder</span>
            <h2 className="section-heading" style={{ marginBottom: '0.5rem' }}>
              Charles Brook
            </h2>
            <p className="about__role">AI Solutions Architect &amp; Principal Consultant</p>

            <div className="rule" />

            <p className="about__bio">
              Charles Brook is an AI Solutions Architect and former Principal Consultant with
              30 years of software engineering experience. He has built production AI agents
              for companies ranging from regulated crypto exchanges to major UK banks — navigating
              compliance environments and legacy integration challenges that most AI vendors
              simply don&rsquo;t encounter.
            </p>
            <p className="about__bio">
              NorthCortex exists to bring that depth of expertise to ambitious Northern businesses.
              Not as a vendor selling a product, but as a practitioner who will work alongside
              your team — understanding your systems, your constraints, and your goals — and
              deliver AI agents that earn their place in production.
            </p>

            <div className="about__stats">
              <div className="about__stat">
                <span className="about__stat-value">30+</span>
                <span className="about__stat-label">Years engineering</span>
              </div>
              <div className="about__stat">
                <span className="about__stat-value">Banks<br/>to Crypto</span>
                <span className="about__stat-label">Production deployments</span>
              </div>
              <div className="about__stat">
                <span className="about__stat-value">Principal</span>
                <span className="about__stat-label">Consulting level</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

function PersonIcon() {
  return (
    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
      <circle cx="12" cy="7" r="4"/>
    </svg>
  )
}

function ShieldIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    </svg>
  )
}
